import React from "react";
import Switch from "react-switch";
import { useTranslation } from "react-i18next";
import { cls } from "app/utils";
import DropdownButton from "app/components/DropdownButton";
import styles from "./styles.module.scss";

interface IProps {
  title: string;
  subtitle?: string;
  iconClass: string;
  enabled: boolean;
  onToggle: (_enabled: boolean) => void;
  onStepClick?: () => void;
}

const WorkflowStep = ({
  title,
  subtitle,
  iconClass,
  enabled,
  onToggle,
  onStepClick,
}: IProps) => {
  const { t } = useTranslation();

  const handleToggle = (checked: boolean) => {
    onToggle(checked);
  };

  const handleCardClick = () => {
    onStepClick?.();
  };

  const handleEditClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onStepClick?.();
  };

  return (
    <div
      className={cls(styles.container, { [styles.disabled]: !enabled })}
      onClick={handleCardClick}
    >
      <div className={styles.step_info}>
        <div className={styles.icon_wrapper}>
          <i className={cls("ico", iconClass)} />
        </div>
        <div className={styles.text_wrapper}>
          <span className={styles.title}>{title}</span>
          {subtitle && <span className={styles.subtitle}>{subtitle}</span>}
        </div>
      </div>
      <div
        className={styles.step_actions}
        onClick={(e) => e.stopPropagation()}
      >
        <Switch
          checked={enabled}
          onChange={handleToggle}
          offColor="#CECECE"
          onColor="#27A4FF"
          onHandleColor="#FFFFFF"
          handleDiameter={20}
          uncheckedIcon={false}
          checkedIcon={false}
          height={24}
          width={40}
          className="react-switch"
        />
        <DropdownButton
          btnClassName={styles.menu_btn}
          btnContent={<i className="bullets" />}
          closeOnClick
        >
          <div className={styles.dropdown_container}>
            <div className={styles.dropdown_item} onClick={handleEditClick}>
              {t("Edit Step")}
            </div>
          </div>
        </DropdownButton>
      </div>
    </div>
  );
};

export default WorkflowStep;
